import Vue from "vue";
import Vuex from "vuex";
import getters from "./getters";
import mutations from "./mutations";

Vue.use(Vuex);

const state = {
  sidebarShow: "responsive",
  sidebarMinimize: true,
  pathTitle: null,
  fileList: [],
  uploadProgress: null,
  barColor: "rgba(0, 0, 0, .8), rgba(0, 0, 0, .8)",
  barImage: "",
  drawer: null,
  backImgId: "",
  textImgId: "",
  picImgId: "",
  shapImgId: "",
  textcolor: "",
  shapcolor: "",
  filter: null
};

import userModule from "./modules/user";
import questionnaireModule from "./modules/questionnaire";
import organizationModule from "./modules/organization";
import formModule from "./modules/form";
import strategiesModule from "./modules/strategies";
import wordsModule from "./modules/words";
import topicsModule from "./modules/topics";
import contactsModule from "./modules/contacts";
import groupsModule from "./modules/groups";
import cmsModule from "./modules/cms";
import attributesModule from "./modules/attributes";

import teamsModule from "./modules/teams";

import roleModule from "./modules/role";
import logModule from "./modules/log";
import settingModule from "./modules/setting";
import courseModule from "./modules/course";
import storyModule from "./modules/story";
import dashboardModule from "./modules/dashboard";
import languageModule from "./modules/language";
import tasksModule from "./modules/tasks";

import topicsCardModule from "./modules/topics_card";
import subTopicsCardModule from "./modules/sub_topics_card";
import dataCardsModule from "./modules/data_cards";
import taskCardsModule from "./modules/task_cards";
import studentsNotebookModule from "./modules/students_notebook";
import strategiesCardModule from "./modules/strategies_card";

const store = new Vuex.Store({
  modules: {
    questionnaire: questionnaireModule,
    user: userModule,
    roles: roleModule,
    logs: logModule,
    courses: courseModule,
    setting: settingModule,
    story: storyModule,
    organization: organizationModule,
    form: formModule,
    language: languageModule,
    strategies: strategiesModule,
    dashboard: dashboardModule,
    topics: topicsModule,
    contacts: contactsModule,
    groups: groupsModule,
    words: wordsModule,
    cms: cmsModule,
    attributes: attributesModule,
    tasks: tasksModule,
    teams: teamsModule,
    topics_card: topicsCardModule,
    sub_topics_card: subTopicsCardModule,
    data_cards: dataCardsModule,
    task_cards: taskCardsModule,
    students_notebook: studentsNotebookModule,
    strategies_card: strategiesCardModule
  },
  mutations: mutations,
  state: state,
  getters
});

export default store;
